import React, { createContext, useContext, useState, useEffect } from "react";
import { getFilteredPlaylists } from "../helper/Playlists/playlist";

const DataContext = createContext();

export const useData = () => {
  return useContext(DataContext);
};

export const DataProvider = ({ children }) => {
  const [titles, setTitles] = useState([]);

  useEffect(() => {
    const fetchPlaylists = async () => {
      try {
        // Load from localStorage first
        const cached = localStorage.getItem("playlistTitles");
        if (cached) {
          setTitles(JSON.parse(cached));
        }

        const response = await getFilteredPlaylists("all", 1, 1000, "newest", {
          languages: "",
          rating: "",
        });

        if (response && response.success) {
          const playlists = response.data?.playlist || [];

          const suggestions = playlists
            .flatMap((playlist) => [
              playlist.name, // playlist name
              // ...(playlist.videos || []).map((v) => v.title), // all video titles
            ])
            .filter(Boolean);

          setTitles(suggestions);

          localStorage.setItem("playlistTitles", JSON.stringify(suggestions));
        }
      } catch (error) {
        console.error("Failed to fetch playlist titles", error);
      }
    };

    fetchPlaylists();
  }, []);

  return (
    <DataContext.Provider value={{ titles }}>{children}</DataContext.Provider>
  );
};
